import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { completeLogin } from '@/auth/oauth'

export default function Callback() {
  const [params] = useSearchParams()
  const nav = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    completeLogin(params)
      .then(() => nav('/', { replace: true }))
      .catch((e) => setError(e instanceof Error ? e.message : String(e)))
  }, [params, nav])

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="text-base text-stone-500 mb-6">Lensify</div>
        {error ? (
          <>
            <h1 className="text-2xl font-semibold mb-3 text-red-600">Login failed</h1>
            <p className="text-stone-600 text-sm mb-6">{error}</p>
            <button
              onClick={() => nav('/login', { replace: true })}
              className="px-4 py-2 rounded-md border border-stone-300 hover:bg-stone-100 transition-colors"
            >
              Try again
            </button>
          </>
        ) : (
          <p className="text-stone-600">Finishing sign in…</p>
        )}
      </div>
    </div>
  )
}
